import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { Chip, ChipIconTimes, ChipIconWrapper } from '../Chip'

import uniqid from 'uniqid'

const uuid = uniqid()

const Single = ({ selection, placeholder }) => {
  return selection ? (
    <span
      className='e-select__selected-item e-select__selected-item--single'
      data-mu-test={`selected__option ${selection.value}`}
    >
      {selection.label}
    </span>
  ) : (
    <span className='e-select__placeholder'>{placeholder}</span>
  )
}

Single.propTypes = {
  selection: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  placeholder: PropTypes.string
}

const MemoSingle = React.memo(Single)

export const SelectSelected = ({
  selection,
  placeholder,
  onRemove,
  children,
  SelectedItemComponent,
  disabled
}) => {
  const multiple = Array.isArray(selection)

  const handleClickItem = (value, e) => {
    e.stopPropagation()
    onRemove(value)
  }

  const MySingle = SelectedItemComponent || MemoSingle

  const Multiple = () =>
    !selection.length ? (
      <span className='e-select__placeholder'>{placeholder}</span>
    ) : (
      selection.map(
        ({ label, value, disabled: itemDisabled, ...otherProps }, i) => (
          <div
            key={`e-select__selected-item-${i}-${uuid}`}
            data-mu-test={`selected__option ${value}`}
            className={classnames(
              'e-select__selected-item e-select__selected-item--multiple',
              {
                'e-select__selected-item--multiple--disabled': disabled
              }
            )}
          >
            {SelectedItemComponent ? (
              <SelectedItemComponent
                icon={disabled ? undefined : 'times'}
                onClick={disabled ? undefined : handleClickItem}
                label={label}
                value={value}
                disabled={disabled}
                {...otherProps}
              />
            ) : (
              <Chip
                label={label}
                value={value}
                disabled={disabled}
                {...otherProps}
              >
                {!itemDisabled && (
                  <ChipIconWrapper
                    onClick={
                      itemDisabled ? undefined : e => handleClickItem(value, e)
                    }
                  >
                    <ChipIconTimes />
                  </ChipIconWrapper>
                )}
              </Chip>
            )}
          </div>
        )
      )
    )

  return (
    <>
      {!multiple ? (
        <MySingle selection={selection} placeholder={placeholder} />
      ) : (
        <Multiple />
      )}
      {children}
    </>
  )
}

SelectSelected.defaultProps = {
  isOnlyText: true,
  SelectedItemComponent: undefined,
  disabled: false
}

SelectSelected.propTypes = {
  children: PropTypes.any,
  selection: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  placeholder: PropTypes.string,
  onRemove: PropTypes.func,
  SelectedItemComponent: PropTypes.any,
  disabled: PropTypes.bool
}
